module.exports = __webpack_public_path__ + "img/icon_location_in_active.5f5a94c2.png";